import { render, staticRenderFns } from "./DynamicField.vue?vue&type=template&id=524e63ee&scoped=true&lang=pug"
import script from "./DynamicField.vue?vue&type=script&lang=js"
export * from "./DynamicField.vue?vue&type=script&lang=js"
import style0 from "./DynamicField.vue?vue&type=style&index=0&id=524e63ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e63ee",
  null
  
)

export default component.exports